module.exports = __webpack_public_path__ + "assets/images/project/south-africa-desktop.jpg?v=c81c0767";